import { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';

import { Tariffs } from '../../home';
import { FiltersBlock, SearchResult } from '../../tariffs';

const TariffsFilter = ({ data }) => {
  const router = useRouter();
  const [tariffs, setTariffs] = useState(data?.sliders);
  const [searchedTariffs, setSearchedTariffs] = useState([]);
  const typeParam = router.query?.type;
  const subscriptionParam = router.query?.subscription;
  const advantagesParam = router.query?.advantages;
  const priceFrom = router.query?.priceFrom;
  const priceTo = router.query?.priceTo;

  const filterTariffs = useCallback(
    (
      priceFrom = -Infinity,
      priceTo = Infinity,
      type = [],
      subscription = [],
      advantages = [],
    ) => {
      const filtered = tariffs ?? [];
      let filteredTariffs = [];
      filtered.find((p) =>
        p.tariffs.some((item) =>
          item.tags.some((t) => {
            if (type.includes(String(t.id))) {
              filteredTariffs.push(item);
            }
            return null;
          }),
        ),
      );
      if (subscription) {
        filteredTariffs.find((item) =>
          item.tags.some((t) => {
            if (subscription.includes(String(t.id))) {
              filteredTariffs.push(item);
            }
            return null;
          }),
        );
      }
      if (advantages) {
        filteredTariffs.find((item) =>
          item.tags.some((t) => {
            if (advantages.includes(String(t.id))) {
              filteredTariffs.push(item);
            }
            return null;
          }),
        );
      }
      if (priceFrom || priceTo) {
        filteredTariffs = filteredTariffs.filter(
          (item) =>
            (+priceFrom || -Infinity) <= +item.price &&
            +item.price <= (+priceTo || Infinity),
        );
      }
      return filteredTariffs;
    },
    [tariffs],
  );

  const renderTariffs = (tarif) => {
    return (
      <Tariffs
        data={tarif}
        footerData={tarif?.tags}
        title={tarif?.title}
        buttonText={tarif?.button_text}
        itemScope
        itemType='https://schema.org/Offer'
      />
    );
  };

  useEffect(() => {
    setTariffs(data?.sliders);
    if (
      priceFrom ||
      priceTo ||
      typeParam ||
      subscriptionParam ||
      advantagesParam
    ) {
      setSearchedTariffs(
        filterTariffs(
          priceFrom,
          priceTo,
          typeParam,
          subscriptionParam,
          advantagesParam,
        ),
      );
    } else {
      setSearchedTariffs([]);
    }
  }, [
    data?.sliders,
    typeParam,
    subscriptionParam,
    advantagesParam,
    priceFrom,
    priceTo,
    filterTariffs,
  ]);
  return (
    <>
      <FiltersBlock
        type={data.selects.find((s) => s.type === 'type')}
        subscription={data.selects.find((s) => s.type === 'subscription')}
        advantages={data.selects.find((s) => s.type === 'advantages')}
        applyText={data?.filter_button_text}
        resetText={data?.reset_button_text}
        maxText={data?.max_price_text}
        minText={data?.min_price_text}
        itemScope
        itemType='https://schema.org/Filter'
      />
      {searchedTariffs.length > 0 && (
        <SearchResult
          data={searchedTariffs}
          itemScope
          itemType='https://schema.org/ItemList'
        />
      )}
      {data?.sliders?.length > 0 &&
        !searchedTariffs.length &&
        tariffs.map(renderTariffs)}
    </>
  );
};

export default TariffsFilter;
